// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════
   GestionHostPanel  —  prefijo: gh-
   Mismo sistema visual que pc- y pe-
   ═══════════════════════════════════════════════ */
.gh-panel {
  position: absolute;
  top: 15%;
  right: 3%;
  z-index: 10;

  width: 252px;
  background: #ffffff;
  border: 1.5px solid var(--second-color);
  border-radius: 12px;
  overflow: hidden;
  font-family: sans-serif;
  font-size: 13px;
  color: #1a1a1a;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);
  margin-top: 8px;
}

/* ── Header ─────────────────────────────────────── */
.gh-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 14px;
  cursor: pointer;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);
  -webkit-user-select: none;
          user-select: none;
}
.gh-header:hover { background: rgba(0, 0, 0, 0.03); }

.gh-header-left {
  display: flex;
  align-items: center;
  gap: 6px;
}
.gh-title {
  font-size: 13px;
  font-weight: 500;
  color: #1a1a1a;
}
.gh-toggle {
  font-size: 14px;
  color: #888;
  line-height: 1;
}

/* ── Badges del header ───────────────────────────── */
.gh-badge {
  font-size: 10px;
  font-weight: 500;
  padding: 2px 6px;
  border-radius: 6px;
}
.gh-badge--exc  { background: #EEEDFE; color: #534AB7; }
.gh-badge--mtto { background: #FAEEDA; color: #854F0B; }

/* ── Hint ────────────────────────────────────────── */
.gh-hint {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 14px;
  font-size: 11px;
  color: #888;
  background: #fafafa;
  border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);
}
.gh-hint-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}
.gh-hint-dot--exc  { background: #7F77DD; }
.gh-hint-dot--mtto { background: #EF9F27; }

/* ── Cuerpo ──────────────────────────────────────── */
.gh-body {
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* ── Campo ───────────────────────────────────────── */
.gh-field {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.gh-label {
  font-size: 11px;
  color: #888;
}
.gh-select {
  background: #f5f5f5;
  color: #1a1a1a;
  border: 0.5px solid rgba(0, 0, 0, 0.14);
  border-radius: 8px;
  padding: 7px 10px;
  font-size: 12px;
  width: 100%;
  cursor: pointer;
  outline: none;
  appearance: auto;
}
.gh-select:focus {
  border-color: rgba(83, 74, 183, 0.5);
  box-shadow: 0 0 0 3px rgba(83, 74, 183, 0.1);
}

/* ── Chips de estado ─────────────────────────────── */
.gh-status-row {
  display: flex;
  gap: 6px;
}
.gh-chip {
  flex: 1 1;
  text-align: center;
  font-size: 11px;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 6px;
}
.gh-chip--off      { background: #f0f0f0; color: #aaa; }
.gh-chip--exc-on   { background: #EEEDFE; color: #534AB7; }
.gh-chip--mtto-on  { background: #FAEEDA; color: #854F0B; }

/* ── Botones de acción ───────────────────────────── */
.gh-actions {
  display: flex;
  gap: 6px;
}
.gh-btn {
  flex: 1 1;
  border: none;
  border-radius: 8px;
  padding: 8px 6px;
  font-size: 11px;
  font-weight: 500;
  cursor: pointer;
  transition: opacity 0.15s, transform 0.1s;
}
.gh-btn:hover  { opacity: 0.88; }
.gh-btn:active { transform: scale(0.97); }
.gh-btn--exc   { background: #7F77DD; color: #fff; }
.gh-btn--mtto  { background: #EF9F27; color: #fff; }`, "",{"version":3,"sources":["webpack://./src/components/monitor-components/AfiliationMap/styles/PanelCorrelaciones.css"],"names":[],"mappings":"AAAA;;;oDAGoD;AACpD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;;EAEX,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;EACvC,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,yCAAyC;EACzC,eAAe;AACjB;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,eAAe;EACf,8CAA8C;EAC9C,yBAAiB;UAAjB,iBAAiB;AACnB;AACA,mBAAmB,+BAA+B,EAAE;;AAEpD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;AACvD,kBAAkB,mBAAmB,EAAE,cAAc,EAAE;;AAEvD,uDAAuD;AACvD;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,8CAA8C;AAChD;AACA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;AACA,qBAAqB,mBAAmB,EAAE;AAC1C,qBAAqB,mBAAmB,EAAE;;AAE1C,uDAAuD;AACvD;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,WAAW;EACX,eAAe;EACf,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,4CAA4C;AAC9C;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,SAAO;EACP,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;AACA,qBAAqB,mBAAmB,EAAE,WAAW,EAAE;AACvD,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;AAC1D,qBAAqB,mBAAmB,EAAE,cAAc,EAAE;;AAE1D,uDAAuD;AACvD;EACE,aAAa;EACb,QAAQ;AACV;AACA;EACE,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yCAAyC;AAC3C;AACA,iBAAiB,aAAa,EAAE;AAChC,iBAAiB,sBAAsB,EAAE;AACzC,iBAAiB,mBAAmB,EAAE,WAAW,EAAE;AACnD,iBAAiB,mBAAmB,EAAE,WAAW,EAAE","sourcesContent":["/* ═══════════════════════════════════════════════\r\n   GestionHostPanel  —  prefijo: gh-\r\n   Mismo sistema visual que pc- y pe-\r\n   ═══════════════════════════════════════════════ */\r\n.gh-panel {\r\n  position: absolute;\r\n  top: 15%;\r\n  right: 3%;\r\n  z-index: 10;\r\n\r\n  width: 252px;\r\n  background: #ffffff;\r\n  border: 1.5px solid var(--second-color);\r\n  border-radius: 12px;\r\n  overflow: hidden;\r\n  font-family: sans-serif;\r\n  font-size: 13px;\r\n  color: #1a1a1a;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.10);\r\n  margin-top: 8px;\r\n}\r\n\r\n/* ── Header ─────────────────────────────────────── */\r\n.gh-header {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  padding: 10px 14px;\r\n  cursor: pointer;\r\n  border-bottom: 0.5px solid rgba(0, 0, 0, 0.08);\r\n  user-select: none;\r\n}\r\n.gh-header:hover { background: rgba(0, 0, 0, 0.03); }\r\n\r\n.gh-header-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n.gh-title {\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  color: #1a1a1a;\r\n}\r\n.gh-toggle {\r\n  font-size: 14px;\r\n  color: #888;\r\n  line-height: 1;\r\n}\r\n\r\n/* ── Badges del header ───────────────────────────── */\r\n.gh-badge {\r\n  font-size: 10px;\r\n  font-weight: 500;\r\n  padding: 2px 6px;\r\n  border-radius: 6px;\r\n}\r\n.gh-badge--exc  { background: #EEEDFE; color: #534AB7; }\r\n.gh-badge--mtto { background: #FAEEDA; color: #854F0B; }\r\n\r\n/* ── Hint ────────────────────────────────────────── */\r\n.gh-hint {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n  padding: 6px 14px;\r\n  font-size: 11px;\r\n  color: #888;\r\n  background: #fafafa;\r\n  border-bottom: 0.5px solid rgba(0, 0, 0, 0.06);\r\n}\r\n.gh-hint-dot {\r\n  display: inline-block;\r\n  width: 8px;\r\n  height: 8px;\r\n  border-radius: 50%;\r\n  flex-shrink: 0;\r\n}\r\n.gh-hint-dot--exc  { background: #7F77DD; }\r\n.gh-hint-dot--mtto { background: #EF9F27; }\r\n\r\n/* ── Cuerpo ──────────────────────────────────────── */\r\n.gh-body {\r\n  padding: 12px 14px;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n/* ── Campo ───────────────────────────────────────── */\r\n.gh-field {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 4px;\r\n}\r\n.gh-label {\r\n  font-size: 11px;\r\n  color: #888;\r\n}\r\n.gh-select {\r\n  background: #f5f5f5;\r\n  color: #1a1a1a;\r\n  border: 0.5px solid rgba(0, 0, 0, 0.14);\r\n  border-radius: 8px;\r\n  padding: 7px 10px;\r\n  font-size: 12px;\r\n  width: 100%;\r\n  cursor: pointer;\r\n  outline: none;\r\n  appearance: auto;\r\n}\r\n.gh-select:focus {\r\n  border-color: rgba(83, 74, 183, 0.5);\r\n  box-shadow: 0 0 0 3px rgba(83, 74, 183, 0.1);\r\n}\r\n\r\n/* ── Chips de estado ─────────────────────────────── */\r\n.gh-status-row {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n.gh-chip {\r\n  flex: 1;\r\n  text-align: center;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n}\r\n.gh-chip--off      { background: #f0f0f0; color: #aaa; }\r\n.gh-chip--exc-on   { background: #EEEDFE; color: #534AB7; }\r\n.gh-chip--mtto-on  { background: #FAEEDA; color: #854F0B; }\r\n\r\n/* ── Botones de acción ───────────────────────────── */\r\n.gh-actions {\r\n  display: flex;\r\n  gap: 6px;\r\n}\r\n.gh-btn {\r\n  flex: 1;\r\n  border: none;\r\n  border-radius: 8px;\r\n  padding: 8px 6px;\r\n  font-size: 11px;\r\n  font-weight: 500;\r\n  cursor: pointer;\r\n  transition: opacity 0.15s, transform 0.1s;\r\n}\r\n.gh-btn:hover  { opacity: 0.88; }\r\n.gh-btn:active { transform: scale(0.97); }\r\n.gh-btn--exc   { background: #7F77DD; color: #fff; }\r\n.gh-btn--mtto  { background: #EF9F27; color: #fff; }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
